import { connect } from 'react-redux';

import {
  actionCleanupDiscoverProvinceDetails,
  actionCleanupProvincesName,
  actionGetDiscoveryProvinceDetails,
  actionGetProvincesName,
} from 'store/discover-province/actions';
import DiscoveryCategoriesDetails from './DiscoveryProvincesDetails';

const mapStateToProps = (state) => ({
  provinceDetailsLoading: state.DiscoverProvince.provinceDetailsLoading,
  provinceDetails: state.DiscoverProvince.provinceDetails,

  provincesNameLoading: state.DiscoverProvince.provincesNameLoading,
  provincesName: state.DiscoverProvince.provincesName,
});

const mapDispatchToProps = ({
  actionGetDiscoveryProvinceDetails,
  actionCleanupDiscoverProvinceDetails,
  actionGetProvincesName,
  actionCleanupProvincesName,
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscoveryCategoriesDetails);
